<template>
  <v-card variant="flat" style="height: 100%; width: 100%;overflow-y: auto;" class="px-4 py-4">
    <v-row class="pa-2">
      <v-col cols="12" class="py-0 mb-4">
        <h2 class="clientname mb-2">About Client <v-icon :size="20" v-if="role < 6"
            @click="editData('about')">mdi-pencil-box-outline</v-icon></h2>
        <!-- <v-textarea @change="save" class="mt-2 text-focus" :disabled="showDisable == 'about' ? false : true"
          variant="outlined" :rows="4" v-model="client.about_client"></v-textarea> -->
          <QuillEditor
            v-model:content="client.about_client" 
            @change="save"
            contentType="html" 
            theme="snow" 
            :readOnly="showDisable == 'about' ? false : true"
            :key="showDisable == 'about' ? false : true"
            style="height: 130px;"
          />
      </v-col>
      <v-col cols="12" class="pt-0">
        <h2 class="clientname">Logo
          <v-icon v-if="role < 6" class="pl-1" size="20" color="primary" @click="triggerFileInput">
            mdi-plus-circle
          </v-icon>
          <input type="file" ref="fileInput" accept="image/*" style="display: none;" @change="handleFileSelect" />
        </h2>
        <div class="d-flex ga-5 mt-3">
          <img height="100" v-for="(img, idx) in client.logo" :key="idx" :src="`${img.src}`" alt="Logo" />
        </div>
      </v-col>
      <v-col cols="12" class="py-0 mb-4">
        <h2 class="clientname mb-2">Their Clients <v-icon v-if="role < 6" @click="editData('clients')"
            :size="20">mdi-pencil-box-outline</v-icon></h2>
        <!-- <v-textarea @change="save" class="mt-2" variant="outlined" :disabled="showDisable == 'clients' ? false : true"
          :rows="4" v-model="client.their_client"></v-textarea> -->
          <QuillEditor
            v-model:content="client.their_client" 
            @change="save"
            contentType="html" 
            theme="snow" 
            :readOnly="showDisable == 'clients' ? false : true"
            :key="showDisable == 'clients' ? false : true"
            style="height: 130px;"
          />
      </v-col>
      <v-col cols="12" class="py-0 mb-4">
        <h2 class="clientname mb-2">e-commerce Presence <v-icon :size="20" v-if="role < 6"
            @click="editData('presence')">mdi-pencil-box-outline</v-icon></h2>
        <!-- <v-textarea @change="save" class="mt-2" variant="outlined" :disabled="showDisable == 'presence' ? false : true"
          :rows="4" v-model="client.e_commerce_presence"></v-textarea> -->
          <QuillEditor
            v-model:content="client.e_commerce_presence" 
            @change="save"
            contentType="html" 
            theme="snow" 
            :readOnly="showDisable == 'presence' ? false : true"
            :key="showDisable == 'presence' ? false : true"
            style="height: 130px;"
          />
      </v-col>
      <v-col cols="12" class="py-0 mb-4">
        <h2 class="clientname mb-2">Major Customers <v-icon :size="20" v-if="role < 6"
            @click="editData('customers')">mdi-pencil-box-outline</v-icon></h2>
        <!-- <v-textarea @change="save" class="mt-2" variant="outlined" :disabled="showDisable == 'customers' ? false : true"
          :rows="3" v-model="client.customers"></v-textarea> -->
          <QuillEditor
            v-model:content="client.customers" 
            @change="save"
            contentType="html" 
            theme="snow" 
            :readOnly="showDisable == 'customers' ? false : true"
            :key="showDisable == 'customers' ? false : true"
            style="height: 130px;"
          />
      </v-col>
      <v-col cols="12" class="py-0 mb-4">
        <h2 class="clientname mb-2">Average Turnover <v-icon :size="20" v-if="role < 6"
            @click="editData('turnover')">mdi-pencil-box-outline</v-icon></h2>
        <!-- <v-textarea @change="save" class="mt-2" variant="outlined" :disabled="showDisable == 'turnover' ? false : true"
          :rows="3" v-model="client.turnover"></v-textarea> -->
          <QuillEditor
            v-model:content="client.turnover" 
            @change="save"
            contentType="html" 
            theme="snow" 
            :readOnly="showDisable == 'turnover' ? false : true"
            :key="showDisable == 'turnover' ? false : true"
            style="height: 130px;"
          />
      </v-col>
    </v-row>
  </v-card>
  <v-dialog v-model="dialog" width="800">
    <AboutClientForm @close="close" />
  </v-dialog>
</template>

<script>
import AboutClientForm from './AboutClientForm.vue';
import clientDetailsService from '@/api/service/ClientDetails/ClientDetailsService';
import ClientDocumentsService from '@/api/service/ClientDocuments/ClientDocumentsService';
import { QuillEditor } from '@vueup/vue-quill';
import moment from 'moment';
export default {
  components: {
    AboutClientForm,
    QuillEditor
  },
  data() {
    return {
      dialog: false,
      showDisable: '',
      organisationData: [],
      client: {
        "about_client": "",
        "logo": [],
        "their_client": "",
        "e_commerce_presence": "",
        "customers": [],
        "turnover": ""
      },
      role:null
    }
  },
  created() {
    this.getOrganisation();
    let user = JSON.parse(localStorage.getItem('user_details'))
    this.user_id = user.id
    this.role = user.roles.role_type
    console.log(this.role,"this.role!!!")
  },
  methods: {
    async getOrganisation() {
      let $id = this.$route.query.id
      this.organisationData = await clientDetailsService.findOne({ id: $id, collectionName: 'organisation' })
      this.client = this.organisationData && this.organisationData.client ? this.organisationData.client : {
        "about_client": "",
        "logo": [],
        "their_client": "",
        "e_commerce_presence": "",
        "customers": [],
        "turnover": ""
      }
    },
    async save() {
      this.organisationData.client = this.client
      let $data = {
        collectionName: 'organisation',
        data: this.organisationData,
        id: this.$route.query.id
      }
      await clientDetailsService.update($data)
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    async handleFileSelect(event) {
      this.client.logo = this.client && this.client.logo && this.client.logo.length > 0 ? this.client.logo : []
      const file = event.target.files[0];
      let now = moment().format('YYYY-MM-DD HH:mm:ss')
      if (!file) return;

      const reader = new FileReader();
      reader.onload = async (e) => {

        const base64Image = e.target.result;
        console.log(e,"bsdata")
        let logoData = {
          id: this.client.logo.length + 1,
          src: base64Image,  
          created: now,
          modified: null,
          created_by: this.user_id,  
          modified_by: null,
          active: 1,
          deleted: 0,
          deleted_by: null     
        }
        let $json = {
            collectionName: 'documents',
            name: file.name,
            doc_name: file.name,
            file_name: file.name,
            key_type: "uploadFiles",
            key_id: this.$route.query.id,
            file_type: file.type,
            active: 1,
            src: base64Image,
            profile:true
        };
        const docData = await ClientDocumentsService.create($json)
        console.log("Base64 Image:", docData);
        logoData.docid = docData.data.data._id
        logoData.s3Url = docData.data.data.s3Url
        console.log("Base64 Image 1:", logoData);
        this.client.logo.push(logoData)
        this.save()

      };
      reader.readAsDataURL(file);
    },
    editData($event) {
      console.log($event,"$event")
      this.showDisable = $event
    },
    addData() {
      this.dialog = true;

    },
    close() {
      this.dialog = false;
    }
  }
};
</script>

<style scoped>
.clientname {
  font-size: 20px;
  font-weight: 600;
}

.clientdetails {
  margin-top: 15px;
  font-size: 14px;
  font-weight: 400;
}

.claint-list {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
}

>>>.v-textarea .v-field {
  background-color: #e9e9e9 !important;
}

>>>.v-field--variant-outlined.v-field--focused .v-field__outline {
  --v-field-border-width: 0px !important;
}

>>>.v-field__outline {
  --v-field-border-width: 0px !important;
}

>>>.v-field--disabled {
  opacity: 0.5 !important;
}
</style>